import { useEffect } from "react";
import Alert from "react-bootstrap/Alert";
import queryString from "query-string";
import { useLocation, useNavigate } from "react-router-dom";
import { Roles } from "../../data/roles";

import Spinner from "../feature/Spinner";
import Translated from "../feature/Translated";
import { useUserData } from "../../context/UserDataContext";
import { useLoginDatadriversIntegration } from "../../api-new";

const getLandingPageForRole = userRole => {
  userRole = userRole.toLowerCase();

    switch (userRole) {
        case Roles.CONFIGURATOR:
            return "/school-settings/limits";
        default:
            return "/";
    }
}

const LoginDatadriversPage = () => {
    const { login, logout } = useUserData();
    const navigate = useNavigate();
    const location = useLocation();
    const loginIntegrationMutation = useLoginDatadriversIntegration();
    const isPending = loginIntegrationMutation.isPending;
    const isError = loginIntegrationMutation.isError;
    const errorMessage = loginIntegrationMutation.error?.message;

    useEffect(() => {
        const requestParams = queryString.parse(location.search);
        const requestToken = decodeURIComponent(requestParams.token);

        if (!requestToken) {
            navigate("/", { replace: true });
            return;
        }

        if (loginIntegrationMutation.isPending) {
            return;
        }

        if (loginIntegrationMutation.isSuccess) {
            return;
        }

        loginIntegrationMutation.mutate(
            { token: requestToken },
            {
                onSuccess: (data) => {
                    const userRole = data.user.role || Roles.STUDENT;
                    const landingPage = getLandingPageForRole(userRole);
                    logout(false);
                    login({ token: data.token });
                    navigate(landingPage, { replace: true });
                },
            }
        );
    }, [location.search]);

    return (
        <div
            id="login-page"
            className="page-container page-gutter max-width-container"
        >
            <div className="front-center-wrapper">
                <div className="login-form-container fade-in">
                    {isPending && <Spinner />}
                    {isError && (
                        <Alert>
                            <Translated translationKey={errorMessage} />
                        </Alert>
                    )}
                </div>
            </div>
        </div>
    );
};

export default LoginDatadriversPage;
